module.exports = __webpack_public_path__ + "img/design.b0580d8e.svg";